/**
 * Responsibility: describe an aircraft that draws nothing, giving a first-person view.
 *
 * Not a special case anywhere else. It is a normal registry entry with an empty edge list, so the
 * render layer builds a mesh with no segments and every other module — the flight model, the chase
 * camera, tile streaming — carries on exactly as before. Adding a `if (invisible)` branch to the
 * renderer instead would have put a permanent conditional in the hot path to express something the
 * data can say by itself.
 *
 * The camera still sits behind and above where the aircraft is, so this is not quite a cockpit
 * view — it is the same flight with nothing in the way. Which is the point: the wireframe world with
 * no frame around it.
 */

export const invisibleAircraft = {
  id: 'invisible',
  label: 'None',

  /*
    One vertex rather than none. An empty position buffer makes Three.js compute a bounding sphere
    with a NaN radius, which trips frustum-culling warnings; a single point at the origin is
    harmless and keeps the geometry well formed. With no edges referencing it, nothing is drawn.
  */
  vertices: [[0, 0, 0]],
  edges: [],
};
